import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import { AI_TRANSLATIONS } from "@/i18n/ai";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const lang = "en";

  useEffect(() => {
    document.documentElement.lang = lang;
  }, []);

  const t = { ...translations[lang], ai: AI_TRANSLATIONS[lang] };
  return (
    <LanguageContext.Provider value={{ lang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
